"use strict";

var _createClass = require("/home/runner/work/frontend-starter/frontend-starter/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/home/runner/work/frontend-starter/frontend-starter/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _inherits = require("/home/runner/work/frontend-starter/frontend-starter/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/frontend-starter/frontend-starter/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/frontend-starter/frontend-starter/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _wrapNativeSuper = require("/home/runner/work/frontend-starter/frontend-starter/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logWarning = exports.ErrorContext = exports.TypedError = exports.ArgumentTypeError = exports.PositionalArgsError = void 0;

var PositionalArgsError = /*#__PURE__*/function (_Error) {
  _inherits(PositionalArgsError, _Error);

  var _super = _createSuper(PositionalArgsError);

  function PositionalArgsError() {
    _classCallCheck(this, PositionalArgsError);

    return _super.call(this, 'Contract method calls expect named arguments wrapped in object, e.g. { argName1: argValue1, argName2: argValue2 }');
  }

  return _createClass(PositionalArgsError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.PositionalArgsError = PositionalArgsError;

var ArgumentTypeError = /*#__PURE__*/function (_Error2) {
  _inherits(ArgumentTypeError, _Error2);

  var _super2 = _createSuper(ArgumentTypeError);

  function ArgumentTypeError(argName, argType, argValue) {
    _classCallCheck(this, ArgumentTypeError);

    return _super2.call(this, "Expected ".concat(argType, " for '").concat(argName, "' argument, but got '").concat(JSON.stringify(argValue), "'"));
  }

  return _createClass(ArgumentTypeError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.ArgumentTypeError = ArgumentTypeError;

var TypedError = /*#__PURE__*/function (_Error3) {
  _inherits(TypedError, _Error3);

  var _super3 = _createSuper(TypedError);

  function TypedError(message, type, context) {
    var _this;

    _classCallCheck(this, TypedError);

    _this = _super3.call(this, message);
    _this.type = type || 'UntypedError';
    _this.context = context;
    return _this;
  }

  return _createClass(TypedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.TypedError = TypedError;

var ErrorContext = /*#__PURE__*/_createClass(function ErrorContext(transactionHash) {
  _classCallCheck(this, ErrorContext);

  this.transactionHash = transactionHash;
});

exports.ErrorContext = ErrorContext;

function logWarning() {
  if (!process.env['NEAR_NO_LOGS']) {
    var _console;

    (_console = console).warn.apply(_console, arguments);
  }
}

exports.logWarning = logWarning;